import { QuestionPlanPrice as Question } from "@/components/features/items/edit/plan/_shared/ui/components/price";

import { usePlanPrice } from "./hooks";

export const QuestionPlanPrice = () => {
	const {
		isEdited,
		hasError,
		billingTypeTarget,
		price,
		onSetBillingTypeTarget,
		onSetPriceAmount,
	} = usePlanPrice();

	return (
		<Question
			isEdited={isEdited}
			hasError={hasError}
			billingTypeTarget={billingTypeTarget}
			billingTypeTermLabel="１泊ごとに"
			price={price}
			onSetBillingTypeTarget={onSetBillingTypeTarget}
			onSetPriceAmount={onSetPriceAmount}
		/>
	);
};

QuestionPlanPrice.displayName = "QuestionPlanPrice";
